import {
  ContentContainer,
  Ticket,
  TicketBarcodeBackground,
  TicketImgBox,
  TicketWrapper,
  BarcodeTitleText,
} from "./TicketBarcode.styles";
import { TextM, TextMS } from "../../common/text";
import Barcode from "react-barcode";
import { useMediaQuery } from "react-responsive";

const TicketBarcode = ({ setIsCodeOpen, ticket }) => {
  const close = () => {
    setIsCodeOpen(false);
  };
  const isTablet = useMediaQuery({ minWidth: 768 });
  return (
    <ContentContainer onClick={close}>
      <TicketBarcodeBackground>
        <TicketWrapper>
          <TicketImgBox src={ticket.product.images[0]} />
          <Ticket>
            <BarcodeTitleText>
              <TextM>{ticket.product.name}</TextM>
              <br />
              <TextMS>{ticket.validDate}</TextMS>
            </BarcodeTitleText>
            <Barcode
              value={ticket.barcode}
              height={isTablet ? 150 : 75}
              width={isTablet ? 3 : 2}
            />
          </Ticket>
        </TicketWrapper>
      </TicketBarcodeBackground>
    </ContentContainer>
  );
};

export default TicketBarcode;
